import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import type {
  NotificationState,
  ConfirmDialogState,
} from "../hooks/candidate/usePersonnelAssignment";

interface PersonnelNotificationsProps {
  notification: NotificationState;
  onCloseNotification: () => void;
  confirmDialog: ConfirmDialogState;
  onConfirm: () => void;
  onCancel: () => void;
}

const PersonnelNotifications: React.FC<PersonnelNotificationsProps> = ({
  notification,
  onCloseNotification,
  confirmDialog,
  onConfirm,
  onCancel,
}) => (
  <>
    <Dialog open={confirmDialog.open} onClose={onCancel} maxWidth="xs">
      <DialogTitle>Remove {confirmDialog.label}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to remove this{" "}
          {confirmDialog.label.toLowerCase()} assignment?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="inherit">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          Remove
        </Button>
      </DialogActions>
    </Dialog>

    <Snackbar
      open={notification.open}
      autoHideDuration={4000}
      onClose={onCloseNotification}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        onClose={onCloseNotification}
        severity={notification.severity}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {notification.message}
      </Alert>
    </Snackbar>
  </>
);

export default PersonnelNotifications;
